import type {
    AttributeValueType,
    ImageAttributeEntry,
    ImageListAttributeEntry,
    TextAttributeEntry,
} from '../contracts';
import { AttributeImageListModalContent } from './AttributeImageListModalContent';
import { AttributeImageModalContent } from './AttributeImageModalContent';
import { AttributeTextModalContent } from './AttributeTextModalContent';
import type { AttributeModalContentComponent } from './types';

type AttributeModalContentMap = {
    text: AttributeModalContentComponent<TextAttributeEntry>;
    image: AttributeModalContentComponent<ImageAttributeEntry>;
    image_list: AttributeModalContentComponent<ImageListAttributeEntry>;
};

const valueTypeModalContentMap = {
    text: AttributeTextModalContent,
    image: AttributeImageModalContent,
    image_list: AttributeImageListModalContent,
} satisfies AttributeModalContentMap;

export function getAttributeModalContentComponent(
    valueType: AttributeValueType
): AttributeModalContentComponent {
    const Component = valueTypeModalContentMap[valueType];

    if (!Component) {
        throw new Error(
            `Missing Attributes modal content component for value type "${valueType}".`
        );
    }

    return Component as AttributeModalContentComponent;
}
